import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { LangConstant, SystemConstant } from "const";
import { useActiveUser } from "hooks";

const ConfirmActiveDialog = ({ users, isDisable, isShow, onClose, onClear }) => {
  const { t: getLabel } = useTranslation();
  const { activeUser } = useActiveUser();

  const [title, setTitle] = useState("");
  const [errorContent, setErrorContent] = useState(null);

  const handleCloseAfterSuccess = () => {
    onClose();
    onClear();
  };

  const handleSubmit = () => {
    const inactiveUsers = users.filter(user => user.branchAccountStatus === SystemConstant.ACTIVE_STATUS.inactive);
    const activeUsers = users.filter(user => user.branchAccountStatus === SystemConstant.ACTIVE_STATUS.active);
    // FR-WA-03: không kích hoạt bản ghi "Chưa đăng nhập" (PENDING).
    const pendingUsers = users.filter(user => user.state === SystemConstant.STATE.PENDING);
    if (!isDisable && pendingUsers.length > 0) {
      setErrorContent(getLabel(LangConstant.TXT_ACTIVE_ERROR));
    } else if (isDisable && inactiveUsers.length > 0) {
      setErrorContent(getLabel(LangConstant.TXT_INACTIVE_ERROR));
    } else if (!isDisable && activeUsers.length > 0) {
      setErrorContent(getLabel(LangConstant.TXT_ACTIVE_ERROR));
    } else {
      activeUser({
        active: isDisable ? SystemConstant.USER_ACTIVE_STATUS.inactive : SystemConstant.USER_ACTIVE_STATUS.active,
        ids: users.map(item => item.accountId),
        onClose: handleCloseAfterSuccess,
      });
    }
  };

  useEffect(() => {
    setTitle(
      users.length === 1
        ? isDisable
          ? getLabel(LangConstant.FM_REMOVE_SINGLE_PERSON, {
            name: users[0]["name"],
          })
          : getLabel(LangConstant.FM_ACTIVE_SINGLE_PERSON, {
            name: users[0]["name"],
          })
        : isDisable
          ? getLabel(LangConstant.FM_REMOVE_MULTIPLE_PEOPLE, {
            number: users.length,
          })
          : getLabel(LangConstant.FM_ACTIVE_MULTIPLE_PERSON, {
            number: users.length,
          }),
    );
  }, [users]);

  return (
    <Fragment>
      {isShow && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
              <div className="modal-content" style={{ width: 500, padding: "16px", borderRadius: 4 }}>
                <div className="modal-header border-0 justify-content-center">
                  <h5 className="modal-title fw-bold text-center">
                    {isDisable
                      ? getLabel(LangConstant.TXT_CONFIRM_REMOVE_USER_HEADING)
                      : getLabel(LangConstant.TXT_CONFIRM_ACTIVE_USER)}
                  </h5>
                </div>
                <div className="modal-body text-center" style={{ color: "#6C7078", fontSize: 15 }}>
                  {title}
                </div>
                <div className="modal-footer border-0 d-flex gap-2">
                  <button
                    className={`btn ${isDisable ? "btn-danger" : "btn-success"} w-100`}
                    onClick={handleSubmit}
                    style={{ textTransform: "uppercase" }}
                  >
                    {isDisable ? getLabel(LangConstant.L_REMOVE_BUTTON) : getLabel(LangConstant.L_ACTIVE_ACTION)}
                  </button>
                  <button
                    className="btn btn-outline-danger w-100"
                    onClick={onClose}
                    style={{ textTransform: "uppercase" }}
                  >
                    {getLabel(LangConstant.L_CANCEL_BUTTON)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {Boolean(errorContent) && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 1060 }}></div>
          <div className="modal modal-blur fade show d-block" style={{ zIndex: 1061 }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{getLabel(LangConstant.TXT_NOTIFICATION_ERROR_TITLE)}</h5>
                </div>
                <div className="modal-body">{errorContent}</div>
                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={() => setErrorContent(null)}>
                    {getLabel(LangConstant.L_OK)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default ConfirmActiveDialog;

ConfirmActiveDialog.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      name: PropTypes.string,
      state: PropTypes.number,
    }),
  ),

  isShow: PropTypes.bool,

  onClose: PropTypes.func,
  clearCheckedUser: PropTypes.func,
};

ConfirmActiveDialog.defaultProps = {
  onClose: () => { },
  clearCheckedUser: () => { },
};
